module.exports = __webpack_public_path__ + "static/coding-9132803d8eed8d942054e638813aca4b.jpeg";